import { z } from "zod";
import { COURSE_CONTENT_BLOCK_TYPES } from "@/modules/learningCenter/features/CourseManagement/types/course";

export const libraryModuleContentBlockSchema = z.object({
  /** Client-side id for list keying; the server uuid when editing. */
  id: z.string(),
  uuid: z.string().nullable().optional(),
  type: z.enum(COURSE_CONTENT_BLOCK_TYPES),
  content: z.string().nullable().optional(),
  metadata: z.record(z.unknown()).nullable().optional(),
});

export const libraryModuleFormSchema = z.object({
  title: z.string().min(1, "A module title is required"),
  description: z.string().nullable().optional(),
  difficulty: z.string().nullable().optional(),
  estimatedMinutes: z.string().nullable().optional(),
  tags: z.array(z.string()),
  blocks: z.array(libraryModuleContentBlockSchema),
});

export type LibraryModuleFormData = z.infer<typeof libraryModuleFormSchema>;
export type LibraryModuleFormBlock = z.infer<
  typeof libraryModuleContentBlockSchema
>;
